// OpenAI ads measurement pixel. Loaded in production only, and every function
// here is fire-and-forget and never throws, so tracking can never break a
// signup. Payment events are sent from the server only.
import { isProduction } from "./environment";

export const OPENAI_PIXEL_ID = "DBYtfMWhHZEpnmixQG9zn6";
const OPENAI_PIXEL_SRC = "https://bzrcdn.openai.com/sdk/oaiq.min.js";

type OaiqCommand = (...args: unknown[]) => void;

declare global {
  interface Window {
    oaiq?: OaiqCommand & { q?: unknown[] };
  }
}

export const initOpenAIPixel = () => {
  try {
    if (!isProduction || typeof window === "undefined" || window.oaiq) return;

    // Calls made before the script loads are queued and replayed by it.
    const queue = function () {
      // The loader reads the queued calls as arguments objects.
      // eslint-disable-next-line prefer-rest-params
      queue.q.push(arguments);
    } as OaiqCommand & { q: unknown[] };
    queue.q = [];
    window.oaiq = queue;

    const script = document.createElement("script");
    script.async = true;
    script.src = OPENAI_PIXEL_SRC;
    document.head.appendChild(script);

    window.oaiq("init", { pixelId: OPENAI_PIXEL_ID });
  } catch {
    // tracking is optional
  }
};

// The server sends the same event with this id, so OpenAI counts it once.
export const registrationEventId = (accountId: number | string) =>
  `reg_${accountId}`;

export const triggerOpenAIRegistration = (
  accountId: number | string | undefined
) => {
  try {
    if (!accountId || !isProduction || typeof window.oaiq !== "function")
      return;

    window.oaiq(
      "measure",
      "registration_completed",
      { type: "customer_action" },
      { event_id: registrationEventId(accountId) }
    );
  } catch {
    // tracking is optional
  }
};
